module.exports = ":host ::ng-deep label {\n  display: flex;\n  justify-content: space-between; }\n\n:host ::ng-deep input {\n  width: 50%; }\n"